export default __webpack_public_path__ + "static/25-761f61f9734e769a0cfdc8e6e445c9e4.jpg";